import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { useEnv } from "../../context/env.context";
import axios from "axios";
import "../../styles/pages/Values/invite.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import Masonry, { ResponsiveMasonry } from "react-responsive-masonry";
import { Chat } from "../../components/Chat";
import { useAuth0 } from "@auth0/auth0-react";
import { Analytics } from "../../hooks/analytics";
import { EditorState, convertToRaw } from "draft-js";

import { Editor } from "react-draft-wysiwyg";
import draftToHtml from "draftjs-to-html";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";

export const ValueInvite = (props) => {
  const { loginWithRedirect } = useAuth0();
  const history = useHistory();
  const [showModal, setShowModal] = useState(true);
  const { apiServerUrl } = useEnv();
  const [valueImages, setValueImages] = useState([]); // [{id: 1, url: "https://via.placeholder.com/150"}
  const [step, setStep] = useState(0);
  const [invite, setInvite] = useState({}); // {id: 1, name: "Coach", description: "Coach description", image: "https://via.placeholder.com/150"}
  const id = props.match.params.id;
  const [response, setResponse] = useState({}); // {id: 1, name: "Coach", description: "Coach description", image: "https://via.placeholder.com/150"}
  const [chats2] = useState([
    {
      id: 1,
      message: `Wonderful - that's it! They will appreciate you taking the time to help them.`,
      loadingTime: 2000,
      showImage: true,
      type: "coach",
      delay: 2500,
    },
    {
      id: 2,
      showImage: false,
      message:
        "Are you interested in exploring your values? Take a look at the Crew membership.",
      loadingTime: 2000,
      type: "coach",
      delay: 2500,
    },
    {
      id: 3,
      showImage: false,
      loadingTime: 2000,
      type: "program",
      program: "valuesInvite",
      break: true,
    },
  ]);
  const [editorStateOne, setEditorStateOne] = useState(() =>
    EditorState.createEmpty()
  );
  const [editorStateTwo, setEditorStateTwo] = useState(() =>
    EditorState.createEmpty()
  );
  const [editorStateThree, setEditorStateThree] = useState(() =>
    EditorState.createEmpty()
  );

  const toolbar = {
    options: ["inline", "list", "textAlign"],
    inline: {
      options: ["bold", "italic", "underline"],
    },
    list: {
      inDropdown: false,
      className: undefined,
      component: undefined,
      dropdownClassName: undefined,
      options: ["unordered", "ordered"],
    },
    textAlign: {
      inDropdown: false,
      className: undefined,
      component: undefined,
      dropdownClassName: undefined,
      options: ["left", "center", "right", "justify"],
    },
  };
  useEffect(() => {
    const container = document.getElementsByClassName("content_container")[0];
    if (container) {
      container.style = "max-width: 100%;width:100%;";
    }

    const nav = document.getElementsByClassName("nav-bar__container")[0];
    if (nav) {
      nav.style = "display:none";
    }

    return () => {
      const container = document.getElementsByClassName("content_container")[0];
      if (container) {
        container.style = "max-width:96rem";
      }
      const nav = document.getElementsByClassName("nav-bar__container")[0];
      if (nav) {
        nav.style = "display:flex";
      }
    };
  }, []);

  useEffect(() => {
    getValue(id);
    getValueImages(id);
  }, [id]);

  const getValue = async (id) => {
    const config = {
      url: `${apiServerUrl}/api/values/invite/${id}`,
      method: "GET",
      headers: {
        "content-type": "application/json",
      },
    };
    const response = await axios(config);
    const invite = response.data;
    setInvite(invite);
  };

  const saveInvite = async (id) => {
    try {
      const config = {
        url: `${apiServerUrl}/api/values/invite/${id}`,
        method: "PATCH",
        headers: {
          "content-type": "application/json",
        },
        data: {
          response: response,
        },
      };

      await axios(config);

      const config2 = {
        url: `${apiServerUrl}/api/values/invite/${id}/complete`,
        method: "PATCH",
        headers: {
          "content-type": "application/json",
        },
      };
      await axios(config2);
      Analytics("10 Images - Invite Finished");
      setInvite(invite);
    } catch (error) {
      throw error;
    }
  };

  const getValueImages = async (id) => {
    const config = {
      url: `${apiServerUrl}/api/value-image/invite/${id}`,
      method: "GET",
      headers: {
        "content-type": "application/json",
      },
    };
    const response = await axios(config);
    setValueImages(response.data.valueImages);
  };

  if (!invite?.id) {
    return <div></div>;
  }

  if (invite.response) {
    return (
      <div className="valuesInvite">
        <div className="white-background">
          <div className="centerContainer">
            <h3>Thanks for your response!</h3>
            <p>
              {invite.user.first_name} has received your response! Thank you
              again for taking the time to complete it. If you are intersted in
              learning more about Crew you can learn more by hitting the below
              link!
            </p>
            <button
              onClick={() => {
                loginWithRedirect();
              }}
              className="btn primary"
            >
              Learn More
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="valuesInvite">
      {showModal && (
        <div className="modal">
          <div className="modal-content">
            <FontAwesomeIcon
              className="close"
              icon={faTimes}
              onClick={() => setShowModal(false)}
            />
            <div className="left">
              <div className="box">
                <svg
                  width="74"
                  height="74"
                  viewBox="0 0 74 74"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g clipPath="url(#clip0_4_5428)">
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M62.7459 32.1284C61.9754 31.3454 60.9437 30.8735 59.8475 30.8026C58.6811 30.7431 57.5202 30.9987 56.4867 31.5426C55.7539 31.9664 55.0801 32.4847 54.4825 33.0842C54.651 32.2902 54.7745 31.4872 54.8525 30.6792C54.8785 30.4757 54.8458 30.2689 54.7585 30.0833C54.6711 29.8976 54.5326 29.7407 54.3592 29.6309C54.5439 29.5833 54.7101 29.4815 54.8365 29.3387C54.9629 29.1958 55.0436 29.0184 55.0684 28.8292C55.2009 28.2212 55.2732 27.6015 55.2842 26.9792C55.2958 26.5017 55.244 26.0248 55.13 25.5609C54.8897 24.6721 54.4476 23.8508 53.8379 23.1609C53.2282 22.471 52.4675 21.9312 51.615 21.5834C49.9746 20.8785 48.1733 20.6333 46.4042 20.8742C45.4743 20.9891 44.6023 21.3874 43.9067 22.0151C43.9216 21.8407 43.9216 21.6653 43.9067 21.4909C43.8239 21.0313 43.6787 20.5853 43.475 20.1651C43.1664 19.4624 42.7212 18.828 42.1655 18.2987C41.6097 17.7694 40.9544 17.3558 40.2375 17.0817C38.1742 16.3429 35.9184 16.3429 33.855 17.0817C33.1499 17.3443 32.5095 17.7555 31.9775 18.2876C31.4455 18.8196 31.0342 19.46 30.7717 20.1651C30.6858 20.3865 30.6138 20.6131 30.5559 20.8434C30.0488 20.2713 29.4336 19.8052 28.7457 19.4718C28.0578 19.1384 27.3107 18.9444 26.5475 18.9009C24.8448 18.7238 23.1263 19.0226 21.5834 19.7642C20.9855 20.0809 20.4602 20.5186 20.0408 21.0494C19.6214 21.5803 19.3172 22.1927 19.1475 22.8476C18.9151 23.6796 18.8213 24.5442 18.87 25.4067C17.9241 24.8893 16.8648 24.6139 15.7867 24.6051C14.0895 24.6832 12.4467 25.2273 11.0383 26.1776C10.4703 26.5782 9.99091 27.0916 9.63016 27.6858C9.26941 28.2799 9.03504 28.9421 8.94168 29.6309C8.73568 31.3109 8.84019 33.0145 9.25002 34.6567L10.7917 39.8984C11.0903 40.9632 11.4931 41.996 11.9942 42.9817C12.1741 43.3137 12.3914 43.624 12.6417 43.9067C12.4567 45.8492 12.2409 47.8226 12.21 49.7959C12.1722 51.5155 12.3378 53.2335 12.7033 54.9142C12.8876 55.6058 13.1141 56.2854 13.3817 56.9492C13.6838 57.5955 14.0236 58.2236 14.3992 58.8301C15.6523 60.8359 17.5576 62.3493 19.795 63.1159C20.1168 63.2172 20.447 63.2894 20.7817 63.3318C20.5494 64.257 20.3641 65.1935 20.2267 66.1376C20.1959 66.6716 20.1959 67.2069 20.2267 67.7409C20.2267 68.2651 20.2267 68.8201 20.2267 69.3442C20.4117 70.6084 20.72 71.7801 20.9667 73.0443C20.9817 73.1893 21.026 73.3298 21.0969 73.4573C21.1678 73.5847 21.2637 73.6965 21.379 73.7858C21.4943 73.8752 21.6265 73.9402 21.7676 73.977C21.9087 74.0139 22.0558 74.0217 22.2 74.0001C22.3418 73.9961 22.4813 73.9642 22.6107 73.9062C22.7401 73.8483 22.8568 73.7654 22.9542 73.6623C23.0516 73.5592 23.1277 73.438 23.1781 73.3055C23.2286 73.173 23.2525 73.0318 23.2484 72.8901C23.4334 71.6259 23.6492 70.4234 23.7725 69.1592C23.8032 68.6355 23.8032 68.1105 23.7725 67.5867C23.8195 67.0636 23.8195 66.5374 23.7725 66.0142C23.7725 65.1509 23.4642 64.3493 23.2792 63.5784C25.3777 63.6285 27.4677 63.2941 29.4459 62.5917C29.719 62.5128 29.9499 62.3292 30.0885 62.081C30.227 61.8327 30.262 61.5398 30.1859 61.2659C30.15 61.1279 30.0872 60.9983 30.001 60.8847C29.9148 60.7711 29.807 60.6757 29.6837 60.604C29.5604 60.5323 29.4241 60.4858 29.2828 60.4671C29.1414 60.4484 28.9977 60.4579 28.86 60.4951C26.6729 61.0358 24.3871 61.0358 22.2 60.4951C21.2179 60.2359 20.2987 59.7797 19.4983 59.1543C18.6979 58.5288 18.0331 57.7471 17.5442 56.8568L16.2184 53.7734C15.7307 52.3878 15.4098 50.9491 15.2625 49.4876C15.0775 48.1309 14.985 46.7434 14.9234 45.3868C16.3756 45.9252 17.9728 45.9252 19.425 45.3868C21.1528 44.8061 22.5891 43.5797 23.4333 41.9642C23.7367 41.2697 23.9242 40.5302 23.9884 39.7751C24.004 39.6626 24.004 39.5484 23.9884 39.4359C25.2615 39.9054 26.6444 39.9911 27.9658 39.6826C29.6661 39.3218 31.1841 38.3717 32.2517 37.0001C32.9279 37.6707 33.7503 38.1756 34.6544 38.4752C35.5584 38.7748 36.5196 38.8609 37.4625 38.7268C38.2792 38.6176 39.0777 38.3999 39.8367 38.0793C39.9177 38.693 40.1055 39.2878 40.3917 39.8368C40.9247 40.7193 41.6625 41.4603 42.5428 41.9971C43.423 42.5338 44.4197 42.8504 45.4484 42.9201C46.2349 43.0437 47.036 43.0437 47.8225 42.9201L47.0825 44.1842C45.5258 43.3556 43.7894 42.9221 42.0259 42.9221C40.2623 42.9221 38.5259 43.3556 36.9692 44.1842C35.2555 44.998 33.7211 46.1452 32.4559 47.5587C31.1906 48.9722 30.2197 50.6237 29.6 52.4167C29.5305 52.658 29.5556 52.9167 29.6702 53.1401C29.7847 53.3636 29.9802 53.5349 30.2167 53.6192C30.3381 53.6571 30.4659 53.6703 30.5925 53.6581C30.7191 53.6459 30.842 53.6085 30.954 53.5482C31.066 53.4879 31.1648 53.4059 31.2447 53.3069C31.3246 53.2079 31.3839 53.094 31.4192 52.9718C32.0111 51.4705 32.897 50.1026 34.0248 48.9483C35.1526 47.7941 36.4996 46.8767 37.9867 46.2501C39.3466 45.5732 40.8704 45.2951 42.3818 45.4478C43.8932 45.6006 45.3305 46.1781 46.5275 47.1134C46.84 47.3542 47.2343 47.4631 47.6261 47.417C48.0179 47.371 48.3761 47.1735 48.6242 46.8667C50.7825 44.2767 52.4475 41.2551 54.4517 38.5417C54.9142 37.8942 55.4075 37.3084 55.9317 36.6917C56.4824 36.0383 57.1145 35.4581 57.8125 34.9651C58.3198 34.5917 58.9411 34.4064 59.57 34.4409C59.892 34.4929 60.1802 34.6703 60.3717 34.9342C60.7065 35.4308 60.9469 35.9847 61.0809 36.5684C61.4213 37.9872 61.4213 39.4663 61.0809 40.8851C60.7616 42.4299 60.2325 43.9237 59.5084 45.3251C57.7955 49.2362 55.5771 52.9058 52.91 56.2401C51.2024 58.324 48.9179 59.8578 46.3425 60.6493C45.2714 60.9131 44.1764 61.0681 43.0742 61.1117C41.9136 61.1739 40.7506 61.1739 39.59 61.1117C38.5501 61.0179 37.5192 60.8426 36.5067 60.5876C35.4892 60.3101 34.5025 60.0018 33.4234 59.6318C33.2899 59.5771 33.1469 59.5498 33.0028 59.5513C32.8586 59.5528 32.7162 59.5832 32.584 59.6407C32.4518 59.6982 32.3325 59.7816 32.233 59.886C32.1336 59.9903 32.056 60.1136 32.005 60.2484C31.9043 60.5143 31.9126 60.8092 32.0281 61.069C32.1435 61.3288 32.3569 61.5325 32.6217 61.6359C33.6227 62.0849 34.6528 62.4661 35.705 62.7768C36.8109 63.1187 37.9464 63.3562 39.0967 63.4859C40.5974 63.7021 42.1133 63.7949 43.6292 63.7634H45.0475C44.8564 64.4204 44.7121 65.0902 44.6159 65.7676C44.586 66.3119 44.586 66.8574 44.6159 67.4017C44.5853 67.946 44.5853 68.4916 44.6159 69.0359C44.77 70.3001 45.0475 71.5334 45.2942 72.7976C45.2942 73.0838 45.4079 73.3583 45.6103 73.5607C45.8126 73.7631 46.0871 73.8767 46.3734 73.8767C46.6596 73.8767 46.9341 73.7631 47.1364 73.5607C47.3388 73.3583 47.4525 73.0838 47.4525 72.7976C47.6375 71.5334 47.915 70.3001 48.0384 69.0359C48.0701 68.5019 48.0701 67.9666 48.0384 67.4326C48.0681 66.8986 48.0681 66.3633 48.0384 65.8293C48.0384 64.9351 47.73 64.1026 47.5759 63.2393C50.3567 62.3289 52.8606 60.7269 54.8525 58.5834C57.8561 55.1431 60.3863 51.3167 62.3759 47.2059C63.4444 45.4651 64.2447 43.5734 64.75 41.5942C65.237 39.5675 65.237 37.4543 64.75 35.4276C64.3653 34.1789 63.6767 33.0453 62.7459 32.1284ZM20.8125 40.6384C20.2453 41.4805 19.371 42.0671 18.3767 42.2726C17.975 42.4279 17.5424 42.4865 17.1139 42.4437C16.6854 42.4008 16.273 42.2577 15.91 42.0259C15.5968 41.7773 15.3438 41.4611 15.17 41.1009C14.8135 40.3575 14.5246 39.5836 14.3067 38.7884L12.7342 33.9167C12.413 32.9155 12.2061 31.8812 12.1175 30.8334C12.0498 30.4791 12.0706 30.1136 12.1782 29.7694C12.2858 29.4251 12.4768 29.1127 12.7342 28.8601C13.6159 28.119 14.681 27.6291 15.8175 27.4417C16.3654 27.33 16.9323 27.353 17.4694 27.5088C18.0065 27.6645 18.4977 27.9484 18.9009 28.3359C19.0691 28.5345 19.2139 28.7517 19.3325 28.9834L20.165 33.4234C20.338 34.4799 20.6276 35.514 21.0284 36.5068C21.0984 36.6671 21.1809 36.8217 21.275 36.9692C21.2885 37.0613 21.2885 37.1547 21.275 37.2467C21.3521 37.9023 21.3521 38.5646 21.275 39.2201C21.2139 39.7183 21.0569 40.2 20.8125 40.6384ZM29.9083 35.0884C29.2537 35.8645 28.3271 36.3609 27.3183 36.4759C26.8996 36.5845 26.4612 36.5936 26.0383 36.5026C25.6154 36.4116 25.2196 36.2229 24.8825 35.9517C24.6056 35.6732 24.3949 35.336 24.2659 34.9651C23.9667 34.1798 23.7597 33.3623 23.6492 32.5292L22.6317 27.4417C22.4256 26.4269 22.3223 25.3939 22.3233 24.3584C22.3012 23.9936 22.3683 23.6289 22.5187 23.2959C22.6691 22.9628 22.8984 22.6714 23.1867 22.4467C24.1383 21.7847 25.2651 21.4198 26.4242 21.3984C26.9556 21.3594 27.4887 21.445 27.9812 21.6485C28.4737 21.8519 28.9119 22.1675 29.2608 22.5701C29.4615 22.8577 29.6271 23.1682 29.7542 23.4951C29.7542 23.7417 29.7542 23.9884 30.0008 24.2659C30.2475 24.5434 30.0008 24.9751 30.0008 25.3142L30.34 31.1418C30.34 31.8201 30.4942 32.4676 30.6175 33.1459C30.6175 33.3309 30.6175 33.5159 30.6175 33.7009C30.4699 34.2037 30.2293 34.6743 29.9083 35.0884ZM37.3084 35.9826C36.7813 36.0366 36.249 35.964 35.7557 35.7709C35.2623 35.5779 34.8221 35.2699 34.4717 34.8726C34.1457 34.3613 33.945 33.7802 33.8859 33.1768C33.8493 32.3957 33.8596 31.6132 33.9167 30.8334V25.2526C33.8112 24.1348 33.8112 23.0095 33.9167 21.8917C33.9524 21.5091 34.0805 21.1408 34.29 20.8186C34.4994 20.4963 34.784 20.2298 35.1192 20.0417C36.2112 19.4791 37.4424 19.2436 38.665 19.3634C39.2379 19.4057 39.7936 19.5775 40.2904 19.8659C40.7871 20.1544 41.2118 20.5519 41.5325 21.0284C41.7112 21.3589 41.8459 21.7113 41.9334 22.0767C41.9334 22.5084 42.0875 22.9709 42.1492 23.4026C42.1815 23.5698 42.2682 23.7216 42.3959 23.8342C41.7586 25.0772 41.2721 26.3918 40.9467 27.7501L40.0834 33.6084C39.9811 34.2108 39.909 34.818 39.8675 35.4276C39.0726 35.8187 38.1939 36.0093 37.3084 35.9826ZM45.9109 39.5592C45.4319 39.5126 44.9704 39.3544 44.5635 39.0974C44.1566 38.8404 43.8155 38.4917 43.5675 38.0793C43.3989 37.6782 43.3049 37.2498 43.29 36.8151C43.3077 35.925 43.4006 35.0379 43.5675 34.1634L44.4309 28.6442C44.5978 27.3156 44.9833 26.0238 45.5717 24.8209C45.7075 24.5423 45.9017 24.2962 46.1411 24.0993C46.3805 23.9024 46.6596 23.7595 46.9592 23.6801C48.1731 23.3931 49.4427 23.4465 50.6284 23.8342C51.1903 23.9956 51.7051 24.2901 52.1291 24.6926C52.5531 25.0951 52.8738 25.5939 53.0642 26.1467C53.1934 26.5023 53.2561 26.8785 53.2492 27.2567C53.2492 27.6884 53.2492 28.1509 53.2492 28.5826C53.2223 28.7513 53.2426 28.9241 53.3079 29.0819C53.3732 29.2397 53.481 29.3764 53.6192 29.4768C53.3982 29.5246 53.1971 29.6389 53.0428 29.8042C52.8885 29.9695 52.7884 30.178 52.7559 30.4017C52.6017 31.3267 52.3859 32.2517 52.1392 33.1768C51.8925 34.1017 51.5534 35.0267 51.245 35.9209C51.0099 36.5759 50.7104 37.2059 50.3509 37.8018C50.0517 38.3263 49.6413 38.7788 49.1484 39.1276C48.6644 39.4108 48.1289 39.5949 47.573 39.669C47.0172 39.7431 46.4521 39.7058 45.9109 39.5592Z"
                      fill="#FF9E67"
                    />
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M5.76587 16.6191C5.51292 16.3766 5.24518 16.1501 4.9642 15.9407C4.9642 15.9407 2.06587 14.0907 1.3567 14.8307C0.647533 15.5707 2.4667 18.4999 2.49753 18.4999C2.66661 18.7568 2.86304 18.9945 3.08337 19.2091C3.3367 19.4415 3.60445 19.6578 3.88503 19.8566C6.59837 21.7374 6.96837 21.5832 7.52337 21.1207C8.07837 20.6582 8.17087 20.1649 6.32087 17.4207C6.15199 17.1427 5.96666 16.875 5.76587 16.6191Z"
                      fill="#FF9E67"
                    />
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M18.1917 8.78747C18.2686 9.15407 18.3717 9.51472 18.5 9.86663C20.0108 12.95 20.5042 13.2275 21.1825 12.95C21.8608 12.6725 22.2 12.4566 21.7992 8.84913C21.7992 8.4483 21.7992 8.0783 21.5833 7.67747C21.491 7.29385 21.3565 6.9216 21.1825 6.56747C19.4867 3.14497 18.7467 3.48413 18.4075 3.48413C18.0683 3.48413 17.4517 3.69997 17.8217 7.46163C17.9044 7.91392 18.0283 8.3577 18.1917 8.78747Z"
                      fill="#FF9E67"
                    />
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M35.5817 9.77417C36.2601 9.77417 36.6917 9.77417 37.5242 6.105C37.6258 5.73093 37.698 5.34949 37.7401 4.96417C37.7862 4.56466 37.7862 4.16117 37.7401 3.76167C37.2776 0 36.4759 0 36.1367 0C35.7976 0 35.1501 0 34.2251 3.54583C34.1951 3.92552 34.1951 4.30698 34.2251 4.68667C34.1939 5.0766 34.1939 5.4684 34.2251 5.85833C34.4409 9.435 34.8726 9.74333 35.5817 9.77417Z"
                      fill="#FF9E67"
                    />
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M52.6942 14.1217C53.4033 14.3992 53.8658 14.1217 55.7775 11.0383C56.0027 10.6957 56.1987 10.3347 56.3633 9.95916C56.5243 9.56796 56.6582 9.16618 56.7642 8.75666C57.6583 4.87166 56.98 4.68666 56.7642 4.53249C56.5483 4.37832 55.7775 4.03916 53.6808 7.43082C53.4653 7.78477 53.2797 8.15605 53.1258 8.54082C52.9745 8.93251 52.8509 9.33433 52.7558 9.74332C51.7075 13.3817 51.985 13.8442 52.6942 14.1217Z"
                      fill="#FF9E67"
                    />
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M72.5509 18.1299C72.2425 17.8216 71.8417 17.3283 68.45 19.7024C68.1109 19.9799 67.7717 20.2574 67.4634 20.5658C67.1515 20.8837 66.8629 21.2237 66.6 21.5833C64.3492 24.6666 64.2875 25.1908 64.9042 25.7766C65.5209 26.3624 65.9525 26.2699 69.005 24.0191C69.365 23.768 69.7052 23.4897 70.0225 23.1866C70.3531 22.8887 70.6527 22.5581 70.9167 22.1999C73.3834 18.8699 72.8284 18.4999 72.5509 18.1299Z"
                      fill="#FF9E67"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_4_5428">
                      <rect width="74" height="74" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
              </div>
            </div>
            <div className="right">
              <h2>Welcome to Crew, the career design platform</h2>
              <p>
                {invite.user.first_name} has asked you to provide your opinion
                on their values.
              </p>

              <div className="step">
                <div className="number">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="17"
                    height="16"
                    viewBox="0 0 17 16"
                    fill="none"
                  >
                    <path
                      d="M11.188 4.5C11.188 3.70435 10.8719 2.94129 10.3093 2.37868C9.7467 1.81607 8.98364 1.5 8.18799 1.5C7.39234 1.5 6.62928 1.81607 6.06667 2.37868C5.50406 2.94129 5.18799 3.70435 5.18799 4.5C5.18799 5.29565 5.50406 6.05871 6.06667 6.62132C6.62928 7.18393 7.39234 7.5 8.18799 7.5C8.98364 7.5 9.7467 7.18393 10.3093 6.62132C10.8719 6.05871 11.188 5.29565 11.188 4.5ZM3.68799 4.5C3.68799 3.30653 4.16209 2.16193 5.00601 1.31802C5.84992 0.474106 6.99451 0 8.18799 0C9.38146 0 10.5261 0.474106 11.37 1.31802C12.2139 2.16193 12.688 3.30653 12.688 4.5C12.688 5.69347 12.2139 6.83807 11.37 7.68198C10.5261 8.52589 9.38146 9 8.18799 9C6.99451 9 5.84992 8.52589 5.00601 7.68198C4.16209 6.83807 3.68799 5.69347 3.68799 4.5ZM1.72861 14.5H14.6474C14.388 12.8 12.9192 11.5 11.1474 11.5H5.22861C3.45674 11.5 1.99111 12.8 1.72861 14.5ZM0.187988 15.0406C0.187988 12.2562 2.44424 10 5.22861 10H11.1474C13.9317 10 16.188 12.2562 16.188 15.0406C16.188 15.5719 15.7567 16 15.2286 16H1.14736C0.619238 16 0.187988 15.5687 0.187988 15.0406Z"
                      fill="white"
                    />
                  </svg>
                </div>
                <div className="right">
                  <p>
                    First, we'll show you 10 images that{" "}
                    {invite.user.first_name} uploaded that reflect what's most
                    important to them in work and in life.
                  </p>
                </div>
              </div>

              <div className="step">
                <div className="number">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                  >
                    <path
                      d="M14.2846 0.244141C14.2624 0.244141 14.2403 0.245017 14.2177 0.246619C10.7751 0.493499 -0.104331 2.08562 2.44743 12.3224L0.325308 14.4416C0.142215 14.6247 0.142215 14.9215 0.325308 15.1043C0.416796 15.1963 0.536818 15.2431 0.656634 15.2431C0.77645 15.2431 0.896501 15.1974 0.987959 15.1058L3.10715 12.9837C4.16412 13.2471 5.13202 13.368 6.01292 13.368C13.6618 13.368 14.9625 4.30125 15.1852 1.21357C15.2221 0.684736 14.7797 0.244141 14.2846 0.244141ZM6.01175 12.4308C5.34646 12.4308 4.62873 12.336 3.89636 12.1962L5.54332 10.5493C5.55767 10.5501 5.56646 10.556 5.57818 10.556H10.7517C9.47441 11.7951 7.89248 12.4308 6.01175 12.4308ZM11.5485 9.64195C11.5104 9.63316 11.4752 9.61852 11.4372 9.61852H6.47461L8.35622 7.7369C8.36999 7.73778 8.37878 7.74364 8.39049 7.74364H12.6734C12.6289 7.83987 12.5914 7.93857 12.5444 8.03378C12.2457 8.63714 11.9088 9.16152 11.5485 9.64195ZM13.066 6.8062H9.31328L10.3881 5.73137C10.5712 5.54828 10.5712 5.25152 10.3881 5.06872C10.205 4.88592 9.90826 4.88563 9.72546 5.06872L3.263 11.5312C2.74009 9.08242 3.06263 7.02592 4.22183 5.40298C6.64159 2.06628 12.0113 1.32219 14.2465 1.15814C14.1528 2.44858 13.8716 4.66182 13.066 6.8062Z"
                      fill="white"
                    />
                  </svg>
                </div>
                <div className="right">
                  <p>
                    Then, we'll ask you three questions that will help{" "}
                    {invite.user.first_name} see their values from a new
                    perspective.
                  </p>
                </div>
              </div>

              <button
                className="btn secondary"
                onClick={() => setShowModal(false)}
              >
                Let's Begin!
              </button>
            </div>
          </div>
          <div
            onClick={() => {
              setShowModal(false);
            }}
            className="skrim"
          ></div>
        </div>
      )}
      <div className="white-background">
        {step === 1 && (
          <div className="left">
            <h2>Input on values</h2>

            <div className="header">
              <div className="number">
                <h3>1.</h3>
                <h3>
                  From what you're seeing in {invite.user.first_name}'s images,
                  what do you sense is most important to{" "}
                  {invite.user.first_name}?
                </h3>
              </div>
              <p>
                Note: It's not about getting it "right." Get curious about what
                you see and have fun with it! Feel free to add as many
                observations as occur to you.
              </p>
            </div>

            <div className="entry">
              <Editor
                handlePastedText={() => false}
                toolbar={toolbar}
                onEditorStateChange={(e) => {
                  setEditorStateOne(e);
                  let raw = convertToRaw(e.getCurrentContent());
                  let html = draftToHtml(raw);
                  const newResponse = { ...response };
                  newResponse.value1 = {
                    value: html,
                    description: `From what you're seeing in ${invite.user.first_name}'s images, what do you sense is most important to ${invite.user.first_name}?`,
                  };
                  setResponse(newResponse);
                }}
                editorState={editorStateOne}
              />
            </div>

            <div className="bottom">
              <button
                className="btn blank"
                onClick={() => {
                  showModal(true);
                }}
              >
                Go Back
              </button>

              <button
                disabled={response.value1?.value === ""}
                className="btn primary"
                onClick={async () => {
                  setStep(2);
                }}
              >
                Continue
              </button>
            </div>
          </div>
        )}
        {step === 2 && (
          <div className="left">
            <h2>Input on values</h2>

            <div className="header">
              <div className="number">
                <h3>2.</h3>
                <h3>
                  Looking at these images, can you identify any themes or
                  patterns?
                </h3>
              </div>
            </div>

            <div className="entry">
              <Editor
                handlePastedText={() => false}
                toolbar={toolbar}
                onEditorStateChange={(e) => {
                  setEditorStateTwo(e);
                  let raw = convertToRaw(e.getCurrentContent());
                  let html = draftToHtml(raw);
                  const newResponse = { ...response };
                  newResponse.value2 = {
                    value: html,
                    description: `Looking at these images, can you identify any themes or patterns?`,
                  };
                  setResponse(newResponse);
                }}
                editorState={editorStateTwo}
              />
            </div>

            <div className="bottom">
              <button
                className="btn blank"
                onClick={() => {
                  setStep(1);
                }}
              >
                Go Back
              </button>

              <button
                disabled={response.value2?.value === ""}
                className="btn primary"
                onClick={async () => {
                  setStep(3);
                }}
              >
                Continue
              </button>
            </div>
          </div>
        )}
        {step === 3 && (
          <div className="left">
            <h2>Input on values</h2>

            <div className="header">
              <div className="number">
                <h3>3.</h3>
                <h3>
                  What questions are coming up for you as you look at these
                  images? What are you curious about?{" "}
                </h3>
              </div>
            </div>

            <div className="entry">
              <Editor
                handlePastedText={() => false}
                toolbar={toolbar}
                onEditorStateChange={(e) => {
                  setEditorStateThree(e);
                  let raw = convertToRaw(e.getCurrentContent());
                  let html = draftToHtml(raw);
                  const newResponse = { ...response };
                  newResponse.value3 = {
                    value: html,
                    description:
                      "What questions are coming up for you as you look at these images? What are you curious about?",
                  };
                  setResponse(newResponse);
                }}
                editorState={editorStateThree}
              />
            </div>

            <div className="bottom">
              <button
                className="btn blank"
                onClick={() => {
                  setStep(2);
                }}
              >
                Close &amp; Exit
              </button>

              <button
                disabled={response.value3?.value === ""}
                className="btn primary"
                onClick={async () => {
                  setStep(4);
                }}
              >
                Continue
              </button>
            </div>
          </div>
        )}
        {step === 4 && (
          <div className="left">
            <h2>Input on values</h2>

            <div className="header">
              <div className="number">
                <h3>Review your responses before continuing</h3>
              </div>
            </div>

            <div className="entry overflow">
              <div className="responseEdit">
                <div className="number">
                  <h3>1.</h3>
                  <h3>
                    From what you're seeing in {invite.user.first_name}'s
                    images, what do you sense is most important to{" "}
                    {invite.user.first_name}?
                  </h3>
                </div>

                <Editor
                  handlePastedText={() => false}
                  toolbar={toolbar}
                  onEditorStateChange={(e) => {
                    setEditorStateOne(e);
                    let raw = convertToRaw(e.getCurrentContent());
                    let html = draftToHtml(raw);
                    const newResponse = { ...response };
                    newResponse.value1 = {
                      value: html,
                      description: `From what you're seeing in ${invite.user.first_name}'s images, what do you sense is most important to ${invite.user.first_name}?`,
                    };
                    setResponse(newResponse);
                  }}
                  editorState={editorStateOne}
                />
              </div>
              <div className="responseEdit">
                <div className="number">
                  <h3>2.</h3>
                  <h3>
                    Looking at these images, can you identify any themes or
                    patterns?
                  </h3>
                </div>

                <Editor
                  handlePastedText={() => false}
                  toolbar={toolbar}
                  onEditorStateChange={(e) => {
                    setEditorStateTwo(e);
                    let raw = convertToRaw(e.getCurrentContent());
                    let html = draftToHtml(raw);
                    const newResponse = { ...response };
                    newResponse.value2 = {
                      value: html,
                      description: `Looking at these images, can you identify any themes or patterns?`,
                    };
                    setResponse(newResponse);
                  }}
                  editorState={editorStateTwo}
                />
              </div>
              <div className="responseEdit">
                <div className="number">
                  <h3>3.</h3>
                  <h3>
                    What questions are coming up for you as you look at these
                    images? What are you curious about?
                  </h3>
                </div>

                <Editor
                  handlePastedText={() => false}
                  toolbar={toolbar}
                  onEditorStateChange={(e) => {
                    setEditorStateThree(e);
                    let raw = convertToRaw(e.getCurrentContent());
                    let html = draftToHtml(raw);
                    const newResponse = { ...response };
                    newResponse.value3 = {
                      value: html,
                      description:
                        "What questions are coming up for you as you look at these images? What are you curious about?",
                    };
                    setResponse(newResponse);
                  }}
                  editorState={editorStateThree}
                />
              </div>
            </div>

            <div className="bottom">
              <button
                className="btn blank"
                onClick={() => {
                  setStep(3);
                }}
              >
                Close &amp; Exit
              </button>

              <button
                disabled={
                  response.value1.value === "" ||
                  response.value2.value === "" ||
                  response.value3.value === ""
                }
                className="btn primary"
                onClick={async () => {
                  try {
                    await saveInvite(id);
                    setStep(5);
                  } catch (error) {
                    console.log(error);
                  }
                }}
              >
                Continue
              </button>
            </div>
          </div>
        )}
        {step === 5 && (
          <div className="left">
            <h2>
              <FontAwesomeIcon
                onClick={() => {
                  setStep(4);
                }}
                icon={faTimes}
              />{" "}
              Input on values
            </h2>

            <Chat
              chats={chats2}
              hideTitle={true}
              finish={() => {}}
              setStep={(i) => {}}
            />
          </div>
        )}

        {step === 0 && (
          <div className="centerContainer">
            <div className="headerTop">
              <div className="left">
                <h3>{invite.user.first_name}'s Images</h3>
                <p>
                  Take a few moments to review the photos{" "}
                  {invite.user.first_name} picked to represent their values
                </p>
              </div>
              <button
                className="btn secondary"
                onClick={() => {
                  setStep(1);
                }}
              >
                Continue{" "}
              </button>
            </div>
            <ResponsiveMasonry
              columnsCount={3}
              columnsCountBreakPoints={{
                350: 1,
                750: 2,
                900: 3,
                1200: 3,
                1400: 4,
              }}
              className="masonry-grid"
            >
              <Masonry gutter={15}>
                {valueImages.map((highlight) => (
                  <div key={highlight.id} className="single-highlight">
                    <div className="photo">
                      <img src={highlight.url} alt="value" />
                    </div>
                  </div>
                ))}
              </Masonry>
            </ResponsiveMasonry>
          </div>
        )}
        {(step === 1 ||
          step === 2 ||
          step === 3 ||
          step === 4 ||
          step === 5) && (
          <div className="right">
            <h3>{invite.user.first_name}'s Images</h3>
            <p>Review as you are answering the prompts about their values</p>
            <ResponsiveMasonry
              columnsCount={3}
              columnsCountBreakPoints={{
                350: 1,
                750: 2,
                900: 3,
                1200: 3,
                1400: 4,
              }}
              className="masonry-grid"
            >
              <Masonry gutter={15}>
                {valueImages.map((highlight) => (
                  <div key={highlight.id} className="single-highlight">
                    <div className="photo">
                      <img src={highlight.url} alt="value" />
                    </div>
                  </div>
                ))}
              </Masonry>
            </ResponsiveMasonry>
          </div>
        )}
      </div>
    </div>
  );
};
